import Title from "../../components/Title";
import styles from "./QueuePage.module.css";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import { customTheme } from "../../util/constants";
import AppInfoCard from "../ActivatedPage/components/AppInfoCard";
import MobileAppInfoCard from "../ActivatedPage/components/MobileAppInfoCard";
import QueueInfoText from "../ActivatedPage/components/QueueInfoText";

const QueuePage = () => {
  const { width } = useWindowDimensions();
  const isMobile = width < customTheme.breakpoints.values.md;

  if (document.title !== "Activation Queue") {
    document.title = "Activation Queue";
  }

  return (
    <>
      <div
        className={`${styles.upper_page} ${
          isMobile ? styles.mobile : ""
        }`}
      >
        {isMobile ? (
          <>
            <div className={styles.textContainer} style={{padding: "0 15px", marginTop: "20px"}}>
              <Title sx={{paddingBottom: "10px", color: "#FDF9F2"}}>You're in the queue!</Title>
              <QueueInfoText isMobile={isMobile} />
            </div>
            <MobileAppInfoCard />
          </>
        ) : (
          <>
            <Title sx={{color: "#FDF9F2"}}>You're in the queue!</Title>
            <QueueInfoText isMobile={isMobile}/>
            <MobileAppInfoCard />
          </>
        )}
      </div>
      <div className={styles.lower_page}>
        <AppInfoCard />
      </div>
    </>
  );
};

export default QueuePage;
